import React, { useRef, useEffect, useState } from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import './style.scss';

export type TextWithTooltipProps = {
  label: string;
  tooltipText: string;
  tooltipTextAlign: string;
  tooltipIconSize: number;
  tooltipIconColor: string;
  tooltipShowArrow: boolean;
  tooltipBackground: string;
};

export const TextWithTooltip: React.FC<TextWithTooltipProps> = ({
  label,
  tooltipText,
  tooltipTextAlign,
  tooltipIconSize,
  tooltipIconColor,
  tooltipShowArrow,
  tooltipBackground,
}) => {
  const [visible, setVisible] = useState(false);
  const tooltipRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (tooltipRef.current) {
      const tooltipRect = tooltipRef.current.getBoundingClientRect();

      if (tooltipRect.right > window.innerWidth) {
        tooltipRef.current.style.left = 'auto';
        tooltipRef.current.style.right = '0';
        tooltipRef.current.style.setProperty('transform', 'none', 'important');
      }
    }
  }, [visible]);

  return (
    <div
      className="text-with-tooltip-container"
      style={{
        justifyContent: tooltipTextAlign || 'flex-start',
      }}>
      <div
        className="tooltip-label-wrapper"
        dangerouslySetInnerHTML={{ __html: label }}
      />

      <div className="tooltip-icon-wrapper">
        <InfoOutlinedIcon
          onMouseEnter={() => setVisible(true)}
          onMouseLeave={() => setVisible(false)}
          sx={{
            fontSize: tooltipIconSize,
            color: tooltipIconColor,
            cursor: 'pointer',
            verticalAlign: 'middle',
          }}
        />

        {visible && (
          <div style={{ position: 'relative' }}>
            <div
              ref={tooltipRef}
              className="tooltip-text-container"
              style={{
                backgroundColor: tooltipBackground || '#000',
              }}
              dangerouslySetInnerHTML={{ __html: tooltipText }}
            />
            {tooltipShowArrow === false ? (
              <></>
            ) : (
              <div
                className="tooltip-arrow-wrapper"
                style={{
                  borderBottomColor: tooltipBackground || '#000',
                  transform: `translateX(-${tooltipTextAlign === 'flex-end' ? 22 : -16}px)`,
                }}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};
